!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.MessagePack = t() : e.MessagePack = t();
}(this, () => (() => {
  "use strict";

  var e = {
      d: (t, i) => {
        for (var s in i) e.o(i, s) && !e.o(t, s) && Object.defineProperty(t, s, {
          enumerable: !0,
          get: i[s]
        });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
      r: e => {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }
    },
    t = {};
  e.r(t), e.d(t, {
    DecodeError: () => o,
    Decoder: () => D,
    EXT_TIMESTAMP: () => d,
    Encoder: () => b,
    ExtData: () => r,
    ExtensionCodec: () => m,
    decode: () => F,
    decodeArrayStream: () => j,
    decodeAsync: () => $,
    decodeMulti: () => C,
    decodeMultiStream: () => R,
    decodeTimestampExtension: () => g,
    decodeTimestampToTimeSpec: () => p,
    encode: () => B,
    encodeDateToTimeSpec: () => y,
    encodeTimeSpecToTimestamp: () => u,
    encodeTimestampExtension: () => w
  });
  const i = new TextEncoder();
  function s(e, t, i) {
    let s = t;
    const n = s + i,
      r = [];
    let o = "";
    for (; s < n;) {
      const t = e[s++];
      if (128 & t) {
        if (192 == (224 & t)) {
          const i = 63 & e[s++];
          r.push((31 & t) << 6 | i);
        } else if (224 == (240 & t)) {
          const i = 63 & e[s++],
            n = 63 & e[s++];
          r.push((31 & t) << 12 | i << 6 | n);
        } else if (240 == (248 & t)) {
          let i = (7 & t) << 18 | (63 & e[s++]) << 12 | (63 & e[s++]) << 6 | 63 & e[s++];
          i > 65535 && (i -= 65536, r.push(i >>> 10 & 1023 | 55296), i = 56320 | 1023 & i), r.push(i);
        } else r.push(t);
      } else r.push(t);
      r.length >= 4096 && (o += String.fromCharCode(...r), r.length = 0);
    }
    return r.length > 0 && (o += String.fromCharCode(...r)), o;
  }
  const n = new TextDecoder();
  class r {
    constructor(e, t) {
      this.type = e, this.data = t;
    }
  }
  class o extends Error {
    constructor(e) {
      super(e);
      const t = Object.create(o.prototype);
      Object.setPrototypeOf(this, t), Object.defineProperty(this, "name", {
        configurable: !0,
        enumerable: !1,
        value: o.name
      });
    }
  }
  const h = 4294967295;
  function a(e, t, i) {
    const s = Math.floor(i / 4294967296),
      n = i;
    e.setUint32(t, s), e.setUint32(t + 4, n);
  }
  function c(e, t) {
    return 4294967296 * e.getInt32(t) + e.getUint32(t + 4);
  }
  const d = -1,
    f = 4294967295,
    l = 17179869183;
  function u({
    sec: e,
    nsec: t
  }) {
    if (e >= 0 && t >= 0 && e <= l) {
      if (0 === t && e <= f) {
        const t = new Uint8Array(4);
        return new DataView(t.buffer).setUint32(0, e), t;
      }
      {
        const i = e / 4294967296,
          s = 4294967295 & e,
          n = new Uint8Array(8),
          r = new DataView(n.buffer);
        return r.setUint32(0, t << 2 | 3 & i), r.setUint32(4, s), n;
      }
    }
    {
      const i = new Uint8Array(12),
        s = new DataView(i.buffer);
      return s.setUint32(0, t), a(s, 4, e), i;
    }
  }
  function y(e) {
    const t = e.getTime(),
      i = Math.floor(t / 1e3),
      s = 1e6 * (t - 1e3 * i),
      n = Math.floor(s / 1e9);
    return {
      sec: i + n,
      nsec: s - 1e9 * n
    };
  }
  function w(e) {
    return e instanceof Date ? u(y(e)) : null;
  }
  function p(e) {
    const t = new DataView(e.buffer, e.byteOffset, e.byteLength);
    switch (e.byteLength) {
      case 4:
        return {
          sec: t.getUint32(0),
          nsec: 0
        };
      case 8:
        {
          const e = t.getUint32(0);
          return {
            sec: 4294967296 * (3 & e) + t.getUint32(4),
            nsec: e >>> 2
          };
        }
      case 12:
        return {
          sec: c(t, 4),
          nsec: t.getUint32(0)
        };
      default:
        throw new o(`Unrecognized data size for timestamp (expected 4, 8, or 12): ${e.length}`);
    }
  }
  function g(e) {
    const t = p(e);
    return new Date(1e3 * t.sec + t.nsec / 1e6);
  }
  const U = {
    type: d,
    encode: w,
    decode: g
  };
  class m {
    constructor() {
      this.builtInEncoders = [], this.builtInDecoders = [], this.encoders = [], this.decoders = [], this.register(U);
    }
    register({
      type: e,
      encode: t,
      decode: i
    }) {
      if (e >= 0) this.encoders[e] = t, this.decoders[e] = i;else {
        const s = -1 - e;
        this.builtInEncoders[s] = t, this.builtInDecoders[s] = i;
      }
    }
    tryToEncode(e, t) {
      for (let i = 0; i < this.builtInEncoders.length; i++) {
        const s = this.builtInEncoders[i];
        if (null != s) {
          const n = s(e, t);
          if (null != n) return new r(-1 - i, n);
        }
      }
      for (let i = 0; i < this.encoders.length; i++) {
        const s = this.encoders[i];
        if (null != s) {
          const n = s(e, t);
          if (null != n) return new r(i, n);
        }
      }
      return e instanceof r ? e : null;
    }
    decode(e, t, i) {
      const s = t < 0 ? this.builtInDecoders[-1 - t] : this.decoders[t];
      return s ? s(e, t, i) : new r(t, e);
    }
  }
  function x(e) {
    return e instanceof Uint8Array ? e : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : function (e) {
      return e instanceof ArrayBuffer || "undefined" != typeof SharedArrayBuffer && e instanceof SharedArrayBuffer;
    }(e) ? new Uint8Array(e) : Uint8Array.from(e);
  }
  m.defaultCodec = new m();
  class b {
    constructor(e) {
      this.entered = !1, this.extensionCodec = e?.extensionCodec ?? m.defaultCodec, this.context = e?.context, this.useBigInt64 = e?.useBigInt64 ?? !1, this.maxDepth = e?.maxDepth ?? 100, this.initialBufferSize = e?.initialBufferSize ?? 2048, this.sortKeys = e?.sortKeys ?? !1, this.forceFloat32 = e?.forceFloat32 ?? !1, this.ignoreUndefined = e?.ignoreUndefined ?? !1, this.forceIntegerToFloat = e?.forceIntegerToFloat ?? !1, this.pos = 0, this.view = new DataView(new ArrayBuffer(this.initialBufferSize)), this.bytes = new Uint8Array(this.view.buffer);
    }
    clone() {
      return new b({
        extensionCodec: this.extensionCodec,
        context: this.context,
        useBigInt64: this.useBigInt64,
        maxDepth: this.maxDepth,
        initialBufferSize: this.initialBufferSize,
        sortKeys: this.sortKeys,
        forceFloat32: this.forceFloat32,
        ignoreUndefined: this.ignoreUndefined,
        forceIntegerToFloat: this.forceIntegerToFloat
      });
    }
    reinitializeState() {
      this.pos = 0;
    }
    encodeSharedRef(e) {
      if (this.entered) return this.clone().encodeSharedRef(e);
      try {
        return this.entered = !0, this.reinitializeState(), this.doEncode(e, 1), this.bytes.subarray(0, this.pos);
      } finally {
        this.entered = !1;
      }
    }
    encode(e) {
      if (this.entered) return this.clone().encode(e);
      try {
        return this.entered = !0, this.reinitializeState(), this.doEncode(e, 1), this.bytes.slice(0, this.pos);
      } finally {
        this.entered = !1;
      }
    }
    doEncode(e, t) {
      if (t > this.maxDepth) throw new Error(`Too deep objects in depth ${t}`);
      null == e ? this.encodeNil() : "boolean" == typeof e ? this.encodeBoolean(e) : "number" == typeof e ? this.forceIntegerToFloat ? this.encodeNumberAsFloat(e) : this.encodeNumber(e) : "string" == typeof e ? this.encodeString(e) : this.useBigInt64 && "bigint" == typeof e ? this.encodeBigInt64(e) : this.encodeObject(e, t);
    }
    ensureBufferSizeToWrite(e) {
      const t = this.pos + e;
      this.view.byteLength < t && this.resizeBuffer(2 * t);
    }
    resizeBuffer(e) {
      const t = new ArrayBuffer(e),
        i = new Uint8Array(t),
        s = new DataView(t);
      i.set(this.bytes), this.view = s, this.bytes = i;
    }
    encodeNil() {
      this.writeU8(192);
    }
    encodeBoolean(e) {
      !1 === e ? this.writeU8(194) : this.writeU8(195);
    }
    encodeNumber(e) {
      !this.forceIntegerToFloat && Number.isSafeInteger(e) ? e >= 0 ? e < 128 ? this.writeU8(e) : e < 256 ? (this.writeU8(204), this.writeU8(e)) : e < 65536 ? (this.writeU8(205), this.writeU16(e)) : e < 4294967296 ? (this.writeU8(206), this.writeU32(e)) : this.useBigInt64 ? this.encodeNumberAsFloat(e) : (this.writeU8(207), this.writeU64(e)) : e >= -32 ? this.writeU8(224 | e + 32) : e >= -128 ? (this.writeU8(208), this.writeI8(e)) : e >= -32768 ? (this.writeU8(209), this.writeI16(e)) : e >= -2147483648 ? (this.writeU8(210), this.writeI32(e)) : this.useBigInt64 ? this.encodeNumberAsFloat(e) : (this.writeU8(211), this.writeI64(e)) : this.encodeNumberAsFloat(e);
    }
    encodeNumberAsFloat(e) {
      this.forceFloat32 ? (this.writeU8(202), this.writeF32(e)) : (this.writeU8(203), this.writeF64(e));
    }
    encodeBigInt64(e) {
      e >= BigInt(0) ? (this.writeU8(207), this.writeBigUint64(e)) : (this.writeU8(211), this.writeBigInt64(e));
    }
    writeStringHeader(e) {
      if (e < 32) this.writeU8(160 + e);else if (e < 256) this.writeU8(217), this.writeU8(e);else if (e < 65536) this.writeU8(218), this.writeU16(e);else {
        if (!(e < 4294967296)) throw new Error(`Too long string: ${e} bytes in UTF-8`);
        this.writeU8(219), this.writeU32(e);
      }
    }
    encodeString(e) {
      const t = function (e) {
        const t = e.length;
        let i = 0,
          s = 0;
        for (; s < t;) {
          let n = e.charCodeAt(s++);
          if (4294967168 & n) {
            if (4294965248 & n) {
              if (n >= 55296 && n <= 56319 && s < t) {
                const t = e.charCodeAt(s);
                56320 == (64512 & t) && (++s, n = ((1023 & n) << 10) + (1023 & t) + 65536);
              }
              i += 4294901760 & n ? 4 : 3;
            } else i += 2;
          } else i++;
        }
        return i;
      }(e);
      var s, n, r;
      this.ensureBufferSizeToWrite(5 + t), this.writeStringHeader(t), s = e, n = this.bytes, r = this.pos, s.length > 50 ? function (e, t, s) {
        i.encodeInto(e, t.subarray(s));
      }(s, n, r) : function (e, t, i) {
        const s = e.length;
        let n = i,
          r = 0;
        for (; r < s;) {
          let i = e.charCodeAt(r++);
          if (4294967168 & i) {
            if (4294965248 & i) {
              if (i >= 55296 && i <= 56319 && r < s) {
                const t = e.charCodeAt(r);
                56320 == (64512 & t) && (++r, i = ((1023 & i) << 10) + (1023 & t) + 65536);
              }
              4294901760 & i ? (t[n++] = i >> 18 & 7 | 240, t[n++] = i >> 12 & 63 | 128, t[n++] = i >> 6 & 63 | 128) : (t[n++] = i >> 12 & 15 | 224, t[n++] = i >> 6 & 63 | 128);
            } else t[n++] = i >> 6 & 31 | 192;
            t[n++] = 63 & i | 128;
          } else t[n++] = i;
        }
      }(s, n, r), this.pos += t;
    }
    encodeObject(e, t) {
      const i = this.extensionCodec.tryToEncode(e, this.context);
      if (null != i) this.encodeExtension(i);else if (Array.isArray(e)) this.encodeArray(e, t);else if (ArrayBuffer.isView(e)) this.encodeBinary(e);else {
        if ("object" != typeof e) throw new Error(`Unrecognized object: ${Object.prototype.toString.apply(e)}`);
        this.encodeMap(e, t);
      }
    }
    encodeBinary(e) {
      const t = e.byteLength;
      if (t < 256) this.writeU8(196), this.writeU8(t);else if (t < 65536) this.writeU8(197), this.writeU16(t);else {
        if (!(t < 4294967296)) throw new Error(`Too large binary: ${t}`);
        this.writeU8(198), this.writeU32(t);
      }
      const i = x(e);
      this.writeU8a(i);
    }
    encodeArray(e, t) {
      const i = e.length;
      if (i < 16) this.writeU8(144 + i);else if (i < 65536) this.writeU8(220), this.writeU16(i);else {
        if (!(i < 4294967296)) throw new Error(`Too large array: ${i}`);
        this.writeU8(221), this.writeU32(i);
      }
      for (const i of e) this.doEncode(i, t + 1);
    }
    countWithoutUndefined(e, t) {
      let i = 0;
      for (const s of t) void 0 !== e[s] && i++;
      return i;
    }
    encodeMap(e, t) {
      const i = Object.keys(e);
      this.sortKeys && i.sort();
      const s = this.ignoreUndefined ? this.countWithoutUndefined(e, i) : i.length;
      if (s < 16) this.writeU8(128 + s);else if (s < 65536) this.writeU8(222), this.writeU16(s);else {
        if (!(s < 4294967296)) throw new Error(`Too large map object: ${s}`);
        this.writeU8(223), this.writeU32(s);
      }
      for (const s of i) {
        const i = e[s];
        this.ignoreUndefined && void 0 === i || (this.encodeString(s), this.doEncode(i, t + 1));
      }
    }
    encodeExtension(e) {
      if ("function" == typeof e.data) {
        const t = e.data(this.pos + 6),
          i = t.length;
        if (i >= 4294967296) throw new Error(`Too large extension object: ${i}`);
        return this.writeU8(201), this.writeU32(i), this.writeI8(e.type), void this.writeU8a(t);
      }
      const t = e.data.length;
      if (1 === t) this.writeU8(212);else if (2 === t) this.writeU8(213);else if (4 === t) this.writeU8(214);else if (8 === t) this.writeU8(215);else if (16 === t) this.writeU8(216);else if (t < 256) this.writeU8(199), this.writeU8(t);else if (t < 65536) this.writeU8(200), this.writeU16(t);else {
        if (!(t < 4294967296)) throw new Error(`Too large extension object: ${t}`);
        this.writeU8(201), this.writeU32(t);
      }
      this.writeI8(e.type), this.writeU8a(e.data);
    }
    writeU8(e) {
      this.ensureBufferSizeToWrite(1), this.view.setUint8(this.pos, e), this.pos++;
    }
    writeU8a(e) {
      const t = e.length;
      this.ensureBufferSizeToWrite(t), this.bytes.set(e, this.pos), this.pos += t;
    }
    writeI8(e) {
      this.ensureBufferSizeToWrite(1), this.view.setInt8(this.pos, e), this.pos++;
    }
    writeU16(e) {
      this.ensureBufferSizeToWrite(2), this.view.setUint16(this.pos, e), this.pos += 2;
    }
    writeI16(e) {
      this.ensureBufferSizeToWrite(2), this.view.setInt16(this.pos, e), this.pos += 2;
    }
    writeU32(e) {
      this.ensureBufferSizeToWrite(4), this.view.setUint32(this.pos, e), this.pos += 4;
    }
    writeI32(e) {
      this.ensureBufferSizeToWrite(4), this.view.setInt32(this.pos, e), this.pos += 4;
    }
    writeF32(e) {
      this.ensureBufferSizeToWrite(4), this.view.setFloat32(this.pos, e), this.pos += 4;
    }
    writeF64(e) {
      this.ensureBufferSizeToWrite(8), this.view.setFloat64(this.pos, e), this.pos += 8;
    }
    writeU64(e) {
      this.ensureBufferSizeToWrite(8), function (e, t, i) {
        const s = i / 4294967296,
          n = i;
        e.setUint32(t, s), e.setUint32(t + 4, n);
      }(this.view, this.pos, e), this.pos += 8;
    }
    writeI64(e) {
      this.ensureBufferSizeToWrite(8), a(this.view, this.pos, e), this.pos += 8;
    }
    writeBigUint64(e) {
      this.ensureBufferSizeToWrite(8), this.view.setBigUint64(this.pos, e), this.pos += 8;
    }
    writeBigInt64(e) {
      this.ensureBufferSizeToWrite(8), this.view.setBigInt64(this.pos, e), this.pos += 8;
    }
  }
  function B(e, t) {
    return new b(t).encodeSharedRef(e);
  }
  function S(e) {
    return `${e < 0 ? "-" : ""}0x${Math.abs(e).toString(16).padStart(2, "0")}`;
  }
  const I = "array",
    E = "map_key",
    A = "map_value",
    v = e => {
      if ("string" == typeof e || "number" == typeof e) return e;
      throw new o("The type of key must be string or number but " + typeof e);
    };
  class k {
    constructor() {
      this.stack = [], this.stackHeadPosition = -1;
    }
    get length() {
      return this.stackHeadPosition + 1;
    }
    top() {
      return this.stack[this.stackHeadPosition];
    }
    pushArrayState(e) {
      const t = this.getUninitializedStateFromPool();
      t.type = I, t.position = 0, t.size = e, t.array = new Array(e);
    }
    pushMapState(e) {
      const t = this.getUninitializedStateFromPool();
      t.type = E, t.readCount = 0, t.size = e, t.map = {};
    }
    getUninitializedStateFromPool() {
      if (this.stackHeadPosition++, this.stackHeadPosition === this.stack.length) {
        const e = {
          type: void 0,
          size: 0,
          array: void 0,
          position: 0,
          readCount: 0,
          map: void 0,
          key: null
        };
        this.stack.push(e);
      }
      return this.stack[this.stackHeadPosition];
    }
    release(e) {
      if (this.stack[this.stackHeadPosition] !== e) throw new Error("Invalid stack state. Released state is not on top of the stack.");
      if (e.type === I) {
        const t = e;
        t.size = 0, t.array = void 0, t.position = 0, t.type = void 0;
      }
      if (e.type === E || e.type === A) {
        const t = e;
        t.size = 0, t.map = void 0, t.readCount = 0, t.type = void 0;
      }
      this.stackHeadPosition--;
    }
    reset() {
      this.stack.length = 0, this.stackHeadPosition = -1;
    }
  }
  const T = new DataView(new ArrayBuffer(0)),
    L = new Uint8Array(T.buffer);
  try {
    T.getInt8(0);
  } catch (e) {
    if (!(e instanceof RangeError)) throw new Error("This module is not supported in the current JavaScript engine because DataView does not throw RangeError on out-of-bounds access");
  }
  const z = new RangeError("Insufficient data"),
    M = new class {
      constructor(e = 16, t = 16) {
        this.hit = 0, this.miss = 0, this.maxKeyLength = e, this.maxLengthPerKey = t, this.caches = [];
        for (let e = 0; e < this.maxKeyLength; e++) this.caches.push([]);
      }
      canBeCached(e) {
        return e > 0 && e <= this.maxKeyLength;
      }
      find(e, t, i) {
        const s = this.caches[i - 1];
        e: for (const n of s) {
          const s = n.bytes;
          for (let n = 0; n < i; n++) if (s[n] !== e[t + n]) continue e;
          return n.str;
        }
        return null;
      }
      store(e, t) {
        const i = this.caches[e.length - 1],
          s = {
            bytes: e,
            str: t
          };
        i.length >= this.maxLengthPerKey ? i[Math.random() * i.length | 0] = s : i.push(s);
      }
      decode(e, t, i) {
        const n = this.find(e, t, i);
        if (null != n) return this.hit++, n;
        this.miss++;
        const r = s(e, t, i),
          o = Uint8Array.prototype.slice.call(e, t, t + i);
        return this.store(o, r), r;
      }
    }();
  class D {
    constructor(e) {
      this.totalPos = 0, this.pos = 0, this.view = T, this.bytes = L, this.headByte = -1, this.stack = new k(), this.entered = !1, this.extensionCodec = e?.extensionCodec ?? m.defaultCodec, this.context = e?.context, this.useBigInt64 = e?.useBigInt64 ?? !1, this.rawStrings = e?.rawStrings ?? !1, this.maxStrLength = e?.maxStrLength ?? h, this.maxBinLength = e?.maxBinLength ?? h, this.maxArrayLength = e?.maxArrayLength ?? h, this.maxMapLength = e?.maxMapLength ?? h, this.maxExtLength = e?.maxExtLength ?? h, this.keyDecoder = void 0 !== e?.keyDecoder ? e.keyDecoder : M, this.mapKeyConverter = e?.mapKeyConverter ?? v;
    }
    clone() {
      return new D({
        extensionCodec: this.extensionCodec,
        context: this.context,
        useBigInt64: this.useBigInt64,
        rawStrings: this.rawStrings,
        maxStrLength: this.maxStrLength,
        maxBinLength: this.maxBinLength,
        maxArrayLength: this.maxArrayLength,
        maxMapLength: this.maxMapLength,
        maxExtLength: this.maxExtLength,
        keyDecoder: this.keyDecoder
      });
    }
    reinitializeState() {
      this.totalPos = 0, this.headByte = -1, this.stack.reset();
    }
    setBuffer(e) {
      const t = x(e);
      this.bytes = t, this.view = new DataView(t.buffer, t.byteOffset, t.byteLength), this.pos = 0;
    }
    appendBuffer(e) {
      if (-1 !== this.headByte || this.hasRemaining(1)) {
        const t = this.bytes.subarray(this.pos),
          i = x(e),
          s = new Uint8Array(t.length + i.length);
        s.set(t), s.set(i, t.length), this.setBuffer(s);
      } else this.setBuffer(e);
    }
    hasRemaining(e) {
      return this.view.byteLength - this.pos >= e;
    }
    createExtraByteError(e) {
      const {
        view: t,
        pos: i
      } = this;
      return new RangeError(`Extra ${t.byteLength - i} of ${t.byteLength} byte(s) found at buffer[${e}]`);
    }
    decode(e) {
      if (this.entered) return this.clone().decode(e);
      try {
        this.entered = !0, this.reinitializeState(), this.setBuffer(e);
        const t = this.doDecodeSync();
        if (this.hasRemaining(1)) throw this.createExtraByteError(this.pos);
        return t;
      } finally {
        this.entered = !1;
      }
    }
    *decodeMulti(e) {
      if (this.entered) {
        const t = this.clone();
        yield* t.decodeMulti(e);
      } else try {
        for (this.entered = !0, this.reinitializeState(), this.setBuffer(e); this.hasRemaining(1);) yield this.doDecodeSync();
      } finally {
        this.entered = !1;
      }
    }
    async decodeAsync(e) {
      if (this.entered) return this.clone().decodeAsync(e);
      try {
        this.entered = !0;
        let t,
          i = !1;
        for await (const s of e) {
          if (i) throw this.entered = !1, this.createExtraByteError(this.totalPos);
          this.appendBuffer(s);
          try {
            t = this.doDecodeSync(), i = !0;
          } catch (e) {
            if (!(e instanceof RangeError)) throw e;
          }
          this.totalPos += this.pos;
        }
        if (i) {
          if (this.hasRemaining(1)) throw this.createExtraByteError(this.totalPos);
          return t;
        }
        const {
          headByte: s,
          pos: n,
          totalPos: r
        } = this;
        throw new RangeError(`Insufficient data in parsing ${S(s)} at ${r} (${n} in the current buffer)`);
      } finally {
        this.entered = !1;
      }
    }
    decodeArrayStream(e) {
      return this.decodeMultiAsync(e, !0);
    }
    decodeStream(e) {
      return this.decodeMultiAsync(e, !1);
    }
    async *decodeMultiAsync(e, t) {
      if (this.entered) {
        const i = this.clone();
        yield* i.decodeMultiAsync(e, t);
      } else try {
        this.entered = !0;
        let i = t,
          s = -1;
        for await (const n of e) {
          if (t && 0 === s) throw this.createExtraByteError(this.totalPos);
          this.appendBuffer(n), i && (s = this.readArraySize(), i = !1, this.complete());
          try {
            for (; yield this.doDecodeSync(), 0 !== --s;);
          } catch (e) {
            if (!(e instanceof RangeError)) throw e;
          }
          this.totalPos += this.pos;
        }
      } finally {
        this.entered = !1;
      }
    }
    doDecodeSync() {
      e: for (;;) {
        const e = this.readHeadByte();
        let t;
        if (e >= 224) t = e - 256;else if (e < 192) {
          if (e < 128) t = e;else if (e < 144) {
            const i = e - 128;
            if (0 !== i) {
              this.pushMapState(i), this.complete();
              continue e;
            }
            t = {};
          } else if (e < 160) {
            const i = e - 144;
            if (0 !== i) {
              this.pushArrayState(i), this.complete();
              continue e;
            }
            t = [];
          } else {
            const i = e - 160;
            t = this.decodeString(i, 0);
          }
        } else if (192 === e) t = null;else if (194 === e) t = !1;else if (195 === e) t = !0;else if (202 === e) t = this.readF32();else if (203 === e) t = this.readF64();else if (204 === e) t = this.readU8();else if (205 === e) t = this.readU16();else if (206 === e) t = this.readU32();else if (207 === e) t = this.useBigInt64 ? this.readU64AsBigInt() : this.readU64();else if (208 === e) t = this.readI8();else if (209 === e) t = this.readI16();else if (210 === e) t = this.readI32();else if (211 === e) t = this.useBigInt64 ? this.readI64AsBigInt() : this.readI64();else if (217 === e) {
          const e = this.lookU8();
          t = this.decodeString(e, 1);
        } else if (218 === e) {
          const e = this.lookU16();
          t = this.decodeString(e, 2);
        } else if (219 === e) {
          const e = this.lookU32();
          t = this.decodeString(e, 4);
        } else if (220 === e) {
          const e = this.readU16();
          if (0 !== e) {
            this.pushArrayState(e), this.complete();
            continue e;
          }
          t = [];
        } else if (221 === e) {
          const e = this.readU32();
          if (0 !== e) {
            this.pushArrayState(e), this.complete();
            continue e;
          }
          t = [];
        } else if (222 === e) {
          const e = this.readU16();
          if (0 !== e) {
            this.pushMapState(e), this.complete();
            continue e;
          }
          t = {};
        } else if (223 === e) {
          const e = this.readU32();
          if (0 !== e) {
            this.pushMapState(e), this.complete();
            continue e;
          }
          t = {};
        } else if (196 === e) {
          const e = this.lookU8();
          t = this.decodeBinary(e, 1);
        } else if (197 === e) {
          const e = this.lookU16();
          t = this.decodeBinary(e, 2);
        } else if (198 === e) {
          const e = this.lookU32();
          t = this.decodeBinary(e, 4);
        } else if (212 === e) t = this.decodeExtension(1, 0);else if (213 === e) t = this.decodeExtension(2, 0);else if (214 === e) t = this.decodeExtension(4, 0);else if (215 === e) t = this.decodeExtension(8, 0);else if (216 === e) t = this.decodeExtension(16, 0);else if (199 === e) {
          const e = this.lookU8();
          t = this.decodeExtension(e, 1);
        } else if (200 === e) {
          const e = this.lookU16();
          t = this.decodeExtension(e, 2);
        } else {
          if (201 !== e) throw new o(`Unrecognized type byte: ${S(e)}`);
          {
            const e = this.lookU32();
            t = this.decodeExtension(e, 4);
          }
        }
        this.complete();
        const i = this.stack;
        for (; i.length > 0;) {
          const e = i.top();
          if (e.type === I) {
            if (e.array[e.position] = t, e.position++, e.position !== e.size) continue e;
            t = e.array, i.release(e);
          } else {
            if (e.type === E) {
              if ("__proto__" === t) throw new o("The key __proto__ is not allowed");
              e.key = this.mapKeyConverter(t), e.type = A;
              continue e;
            }
            if (e.map[e.key] = t, e.readCount++, e.readCount !== e.size) {
              e.key = null, e.type = E;
              continue e;
            }
            t = e.map, i.release(e);
          }
        }
        return t;
      }
    }
    readHeadByte() {
      return -1 === this.headByte && (this.headByte = this.readU8()), this.headByte;
    }
    complete() {
      this.headByte = -1;
    }
    readArraySize() {
      const e = this.readHeadByte();
      switch (e) {
        case 220:
          return this.readU16();
        case 221:
          return this.readU32();
        default:
          if (e < 160) return e - 144;
          throw new o(`Unrecognized array type byte: ${S(e)}`);
      }
    }
    pushMapState(e) {
      if (e > this.maxMapLength) throw new o(`Max length exceeded: map length (${e}) > maxMapLengthLength (${this.maxMapLength})`);
      this.stack.pushMapState(e);
    }
    pushArrayState(e) {
      if (e > this.maxArrayLength) throw new o(`Max length exceeded: array length (${e}) > maxArrayLength (${this.maxArrayLength})`);
      this.stack.pushArrayState(e);
    }
    decodeString(e, t) {
      return !this.rawStrings || this.stateIsMapKey() ? this.decodeUtf8String(e, t) : this.decodeBinary(e, t);
    }
    decodeUtf8String(e, t) {
      if (e > this.maxStrLength) throw new o(`Max length exceeded: UTF-8 byte length (${e}) > maxStrLength (${this.maxStrLength})`);
      if (this.bytes.byteLength < this.pos + t + e) throw z;
      const i = this.pos + t;
      let r;
      return r = this.stateIsMapKey() && this.keyDecoder?.canBeCached(e) ? this.keyDecoder.decode(this.bytes, i, e) : function (e, t, i) {
        return i > 200 ? function (e, t, i) {
          const s = e.subarray(t, t + i);
          return n.decode(s);
        }(e, t, i) : s(e, t, i);
      }(this.bytes, i, e), this.pos += t + e, r;
    }
    stateIsMapKey() {
      return this.stack.length > 0 && this.stack.top().type === E;
    }
    decodeBinary(e, t) {
      if (e > this.maxBinLength) throw new o(`Max length exceeded: bin length (${e}) > maxBinLength (${this.maxBinLength})`);
      if (!this.hasRemaining(e + t)) throw z;
      const i = this.pos + t,
        s = this.bytes.subarray(i, i + e);
      return this.pos += t + e, s;
    }
    decodeExtension(e, t) {
      if (e > this.maxExtLength) throw new o(`Max length exceeded: ext length (${e}) > maxExtLength (${this.maxExtLength})`);
      const i = this.view.getInt8(this.pos + t),
        s = this.decodeBinary(e, t + 1);
      return this.extensionCodec.decode(s, i, this.context);
    }
    lookU8() {
      return this.view.getUint8(this.pos);
    }
    lookU16() {
      return this.view.getUint16(this.pos);
    }
    lookU32() {
      return this.view.getUint32(this.pos);
    }
    readU8() {
      const e = this.view.getUint8(this.pos);
      return this.pos++, e;
    }
    readI8() {
      const e = this.view.getInt8(this.pos);
      return this.pos++, e;
    }
    readU16() {
      const e = this.view.getUint16(this.pos);
      return this.pos += 2, e;
    }
    readI16() {
      const e = this.view.getInt16(this.pos);
      return this.pos += 2, e;
    }
    readU32() {
      const e = this.view.getUint32(this.pos);
      return this.pos += 4, e;
    }
    readI32() {
      const e = this.view.getInt32(this.pos);
      return this.pos += 4, e;
    }
    readU64() {
      const e = (t = this.view, i = this.pos, 4294967296 * t.getUint32(i) + t.getUint32(i + 4));
      var t, i;
      return this.pos += 8, e;
    }
    readI64() {
      const e = c(this.view, this.pos);
      return this.pos += 8, e;
    }
    readU64AsBigInt() {
      const e = this.view.getBigUint64(this.pos);
      return this.pos += 8, e;
    }
    readI64AsBigInt() {
      const e = this.view.getBigInt64(this.pos);
      return this.pos += 8, e;
    }
    readF32() {
      const e = this.view.getFloat32(this.pos);
      return this.pos += 4, e;
    }
    readF64() {
      const e = this.view.getFloat64(this.pos);
      return this.pos += 8, e;
    }
  }
  function F(e, t) {
    return new D(t).decode(e);
  }
  function C(e, t) {
    return new D(t).decodeMulti(e);
  }
  function P(e) {
    return null != e[Symbol.asyncIterator] ? e : async function* (e) {
      const t = e.getReader();
      try {
        for (;;) {
          const {
            done: e,
            value: i
          } = await t.read();
          if (e) return;
          yield i;
        }
      } finally {
        t.releaseLock();
      }
    }(e);
  }
  async function $(e, t) {
    const i = P(e);
    return new D(t).decodeAsync(i);
  }
  function j(e, t) {
    const i = P(e);
    return new D(t).decodeArrayStream(i);
  }
  function R(e, t) {
    const i = P(e);
    return new D(t).decodeStream(i);
  }
  return t;
})());